<template>
  <b-row>
    <StepperCol :step="1" />
    <b-col cols="10" md="11" class="pb-3">
      <div class="d-flex mb-3">
        <h5 class="h3 mb-0 font-weight-normal">取付エリアチェック</h5>
        <b-button @click="helpModalShow = true" variant="link" class="p-0 ml-3">
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 512 512"
            class=""
          >
            <path
              fill="currentColor"
              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
              class=""
            ></path>
          </svg>
        </b-button>
        <b-modal
          centered
          hide-footer
          title="取付可能エリア"
          v-model="helpModalShow"
          >東京都・神奈川県・埼玉県・千葉県・静岡県・愛知県・岐阜県・三重県・大阪府・兵庫県・京都府・奈良県・広島県・岡山県<br />※一部対象対象外の地域がございます。</b-modal
        >
      </div>
      <p class="mb-4 h5 text-muted font-weight-normal">
        郵便番号を入力してください。<br />当社の取付サービス対象エリアかどうかをお調べいたします。
      </p>
      <b-row>
        <b-col cols="12" md="6" class="mb-3">
          <b-form-input
            v-model="inputZip"
            size="lg"
            type="text"
            class="shadow-inset"
            :class="btnVariant"
            placeholder="例: 454-0838"
            v-mask="'###-####'"
            inputmode="numeric"
          >
          </b-form-input>
        </b-col>
        <b-col cols="12" md="5" class="mb-3">
          <b-alert v-if="valid == 1" show variant="success">
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 512 512"
              class=""
            >
              <path
                fill="currentColor"
                d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                class=""
              ></path>
            </svg>
            <span class="h5 ml-2">ご利用いただけます</span><br />{{ address1
            }}{{ address2 }}{{ address3 }}
          </b-alert>
          <b-alert v-if="valid == -1" show variant="danger">
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 576 512"
              class=""
            >
              <path
                fill="currentColor"
                d="M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
                class=""
              ></path>
            </svg>
            <span class="h5 ml-2">サービスエリア対象外です</span><br />
            申し訳ございません。ご指定の地域は弊社がエアコンの取付を行うことができません。<br />{{
              address1
            }}{{ address2 }}{{ address3 }}
          </b-alert>
          <b-alert v-if="valid == -2" show variant="danger">
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 576 512"
              class=""
            >
              <path
                fill="currentColor"
                d="M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
                class=""
              ></path>
            </svg>
            <span class="h5 ml-2">現在受付できないエリアです</span><br />
            申し訳ございません。ご指定の地域は現在受付を停止しています。<br />{{
              address1
            }}{{ address2 }}{{ address3 }}
          </b-alert>
          <b-spinner
            v-if="nowLoading"
            variant="success"
            label="Spinning"
          ></b-spinner>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";
import axiosJsonpAdapter from "axios-jsonp";
import { mask } from "vue-the-mask";

const ZIPCODE_API_URL = "https://zipcloud.ibsnet.co.jp/api/search";

export default {
  directives: { mask },
  components: {
    StepperCol,
  },
  data() {
    return {
      shrinking: false,
      inputZip: "",
      zip: "",
      address1: null,
      address2: null,
      address3: null,
      valid: 0,
      zips: [],
      rules: [(v) => !!v || "必須項目です", (v) => this.checkZip(v)],
      nowLoading: false,
      helpModalShow: false,
    };
  },
  created() {
    const url = "data/zips.json";
    this.axios
      .get(url)
      .then((res) => {
        // console.log('住所データ取得');
        // console.log(res.data);
        this.zips = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  watch: {
    inputZip(val) {
      if (val.length >= 8) {
        this.zip = val.replace("-", "");
        this.buttonClicked();
      }
    },
  },
  mounted() {
    console.log("moounted!!");
    if (this.currentStep == 2) {
      // this.zip = this.storeZip
      this.inputZip = this.storeZip;
    }
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      storeZip() {
        return this.$store.getters.zip;
      },
    }),
    btnVariant() {
      if (this.valid == 0) {
        return "primary";
      } else if (this.valid == 1) {
        return "warning";
      } else {
        return "danger";
      }
    },
    calendars() {
      return this.$store.getters.calendars;
    },
  },
  methods: {
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveZip: "doSaveZip",
      doSaveAddress: "doSaveAddress",
      doSaveCalendar: "doSaveCalendar",
    }),
    buttonClicked() {
      // if (this.zips.includes(parseInt(this.zip))) {
      //   this.valid = 1
      // } else {
      //   this.valid = -1
      // }
      this.nowLoading = true;
      this.doSaveZip(this.zip);
      this.autoAddress();
      // this.doUpdateStep(2)
      // this.shrinking = true
    },
    onPaste() {
      this.zip = null; //コピペ対応
    },

    autoAddress() {
      this.axios
        .get(ZIPCODE_API_URL, {
          adapter: axiosJsonpAdapter,
          params: {
            zipcode: this.zip,
          },
        })
        .then((res) => {
          if (res.data.results !== null && res.data.results !== "null") {
            this.address1 = res.data.results[0].address1;
            this.address2 = res.data.results[0].address2;
            this.address3 = res.data.results[0].address3;
          } else {
            this.address1 = null;
            this.address2 = null;
            this.address3 = null;
          }
          if (this.stopArea()) {
            this.valid = -2;
          } else if (this.zips.includes(parseInt(this.zip))) {
            this.valid = 1;
          } else {
            this.valid = -1;
          }
          this.doSaveAddress({
            address1: this.address1,
            address2: this.address2,
            address3: this.address3,
            isInServiceArea: this.valid === 1,
          });

          this.nowLoading = false;
          this.doUpdateStep(2);
          this.shrinking = true;
        })
        .catch((err) => {
          //例外処理を行う
          console.log(err);
          this.nowLoading = false;
          this.doUpdateStep(2);
          this.shrinking = true;
        });
    },
    // エリアとJSONとを称号して受付停止確認
    stopArea() {
      console.log("受付停止確認");
      let area = this.checkArea(this.address1);
      console.log(this.address1);
      for (let i in this.calendars) {
        //エリアカレンダー選択
        if (this.calendars[i].area == area) {
          console.log(i, this.calendars[i]);
          // this.copyCalendar(i);
          this.doSaveCalendar(JSON.parse(JSON.stringify(this.calendars[i])));
          return this.calendars[i].stop;
        }
      }
      return false;
    },
    checkArea(address1) {
      let area = "関東エリア";
      if (
        address1 == "東京都" ||
        address1 == "神奈川県" ||
        address1 == "千葉県" ||
        address1 == "埼玉県" ||
        address1 == "栃木県" ||
        address1 == "群馬県" ||
        address1 == "山梨県"
      ) {
        area = "関東エリア";
      } else if (
        address1 == "愛知県" ||
        address1 == "三重県" ||
        address1 == "岐阜県" ||
        address1 == "静岡県"
      ) {
        area = "東海エリア";
      } else if (
        address1 == "大阪府" ||
        address1 == "京都府" ||
        address1 == "兵庫県" ||
        address1 == "和歌山県" ||
        address1 == "広島県" ||
        address1 == "岡山県" ||
        address1 == "奈良県"
      ) {
        area = "関西エリア";
      } else if (address1 == "沖縄県") {
        area = "沖縄エリア";
      }
      console.log(area);
      return area;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  &.warning {
    border-color: #fd9000;
  }

  &.danger {
    border-color: #dc3545;
  }
}
</style>